import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Layout from  '@/layout'
import dashRouter from './modules/dashboard.js'
// import testMenuRouter from './modules/testMenu.js'

// import vehicleInsureRouter from './modules/vehicleInsure.js'

/**
 * constantRoutes
 */
export const constantRoutes = [
  { // 刷新重定向使用，先到redirect的页面，再从此页面跳转一下
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path:'/register',
    component:()=>import('@/views/register'),
    hidden:true
  },

  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/sharedetail',
    component: () => import('@/views/vehicleInsure/vehicleInsureShareDetail'),
    hidden: true
  },
  dashRouter,
  // testMenuRouter,
  // vehicleInsureRouter, //（保险）车辆路由
  // vehicleQuoteRouter, //（保险）车辆路由

]

// 异步 route
export const asyncRoutes=[
]

const router = new VueRouter({
  // mode: 'history', // vueRouter的三种模式
  mode:'hash',
  base: process.env.BASE_URL,
  routes: constantRoutes
})

export default router
